import wcs from './../wcs/index'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import get from 'lodash/get'
import { digestMessage } from '../wcs/my-account'
import {devicePixelRatio, LAZY_COMPONENTS_MAP} from '@libs/utils/const'
import md5 from 'md5'

export function loadExternalLibraries(url, callback) {
  const script = document.createElement('script')
  script.setAttribute('src', url)
  script.setAttribute('type', 'text/javascript')
  document.body.appendChild(script)
  script.addEventListener('load', () => {
    callback()
  })
}

export const setEACookie = async () => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const { storeId } = wcs.getStoreConfig()
  let url = `${domain}/wcs/resources/store/${storeId}/espot/EarlyAccess/type/STOREFEATURE`
  let data = {}
  await axios
    .get(url)
    .then(response => {
      data = response.data
    })
    .catch(error => {
      console.error('Failed response from EarlyAccess Espot', error)
    })

  const earlyAccessEnabledPath =
    'MarketingSpotData[0].baseMarketingSpotActivityData[0].baseMarketingSpotActivityName'
  const earlyAccessEnabledValue = get(data, earlyAccessEnabledPath, 'false')
  if (earlyAccessEnabledValue === 'true') {
    window.algoliaConfig.isEarlyAccessParam = 'true2'
    VueCookies.set('earlyAccess', 'true2', Infinity)
    return true
  } else {
    VueCookies.remove('earlyAccess')
    return false
  }
}
export const appendScriptTag = (options) => {
  const {src, content, crossOrigin, type = "text/javascript", async = true, defer = false, id, parent = document.head} = options
  const newScript = document.createElement('script')
  newScript.setAttribute("type", type)
  if(!!src) {
    newScript.setAttribute('src', src)
    if(async) {
      newScript.setAttribute("async", 'true')
    }
    if(defer) {
      newScript.setAttribute("defer", 'true')
    }
    if(!!crossOrigin) {
      newScript.setAttribute('crossorigin', 'anonymous')
    }
  }
  if(!!content) {
    newScript.textContent = content
  }
  if(!!id) {
    newScript.setAttribute('id', id)
  }
  parent.appendChild(newScript)
  return newScript
}

export const loadExternalLibraryAsync = (options) => {
  const {src} = options
  return new Promise((resolve,reject) => {
    const newScript = appendScriptTag(options)
    newScript.addEventListener('error', (e) => {
      reject(`Error loading script ${src} `)
    })
    newScript.onload = () => {
      resolve(newScript)
    }
    newScript.onerror = () => {
      reject(`Failed to load script ${src}`)
    }
  })
}

export const loadExternalStyleAsync = (options) => {
  const {src, crossOrigin} = options
  return new Promise((resolve,reject) => {
    let newStyleNode = document.createElement('link')
    newStyleNode.setAttribute('rel', 'stylesheet')
    newStyleNode.setAttribute('type', 'text/css')
    newStyleNode.setAttribute('href', src)
    if(!!crossOrigin) {
      newStyleNode.setAttribute('crossorigin', 'anonymous')
    }

    document.head.appendChild(newStyleNode)
    newStyleNode.addEventListener('error', (e) => {
      reject(`Error loading style ${src} `)
    })
    newStyleNode.onload = () => {
      resolve(newStyleNode)
    }
    newStyleNode.onerror = () => {
      reject(`Failed to load style ${src}`)
    }
  })
}

const getCookieValue = name =>
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''

export const createCrypto = async (textVal, isPhone) => {
  let crypto = {}
  if(!textVal) {
    return crypto
  }
  let SHA256 = isPhone ? 'SHA256Phone' : 'SHA256Email'
  let MD5Str = isPhone ? 'string_md5_Phone' : 'string_md5'
  let MD5 = isPhone ? MD5Str : 'md5'

  if (getCookieValue(MD5) != '' && getCookieValue(SHA256) != '') {
    crypto = {
      string_md5: getCookieValue(MD5Str),
      sha256: getCookieValue(SHA256),
    }
  } else {
    const result256 = await digestMessage(textVal)
    const resultMd5 = md5(textVal.trim().toLowerCase())
    crypto = {
      string_md5: resultMd5,
      sha256: result256,
    }

    VueCookies.set(MD5Str, crypto.string_md5, null, '/')
    VueCookies.set(SHA256, crypto.sha256, null, '/')
  }
  return crypto
}

export const toggleBodyScrollLock = ({
  enabled = false,
  currentScroll = 0,
  memorizedScroll = window.scrollY,
}) => {
  const $body = document.querySelector('body')
  if (enabled) {
    $body.style.overflow = 'hidden'
    $body.style.position = 'fixed'
    $body.style.top = `-${currentScroll}px`
    $body.classList.add('overflow-hidden')
    $body.classList.add('sgh-body-scroll-lock-enabled')
  } else {
    $body.style.removeProperty('overflow')
    $body.style.removeProperty('position')
    $body.style.removeProperty('top')
    $body.style.removeProperty('width')
    window.scrollTo(0, memorizedScroll)
    $body.classList.remove('overflow-hidden')
    $body.classList.remove('sgh-body-scroll-lock-enabled')
  }
}

export const goToCart = async () => {
  const { storeId, langId, catalogId } = wcs.getStoreConfig()
  window.location.href =
      '/OrderCalculate?updatePrices=1&calculationUsageId=-1&errorViewName=AjaxOrderItemDisplayView' +
      `&catalogId=${catalogId}&langId=${langId}&URL=AjaxOrderItemDisplayView` +
      `&storeId=${storeId}&orderId=.`
}

export const accessibilityArrowNavigation = (parentNodeItem) => {
	if(!parentNodeItem) {
		return false
	}

  let lastFocusedElement = null
	parentNodeItem.addEventListener('keydown', function(e) {
    const focusable = Array.from(parentNodeItem.querySelectorAll('[tabindex]:not([tabindex="-1"])'))
	  const maxlengthNum = focusable.length - 1
		const index = focusable.indexOf(document.activeElement)
		let nextIndexToFocus = null

		if (e.key === 'ArrowDown') {
      e.preventDefault();
			nextIndexToFocus = (index + 1)
			if(nextIndexToFocus > maxlengthNum) {
				nextIndexToFocus = 0
			}
		}

		if (e.key === 'ArrowUp') {
      e.preventDefault();
			nextIndexToFocus = (index - 1)
			if(nextIndexToFocus < 0) {
				nextIndexToFocus = maxlengthNum
			}
		}

		if(nextIndexToFocus !== null) {
      focusable[nextIndexToFocus].focus()
      lastFocusedElement = focusable[nextIndexToFocus]
    }

    if (e.key === 'Enter') {
			if(lastFocusedElement) {
        setTimeout(() => {
          lastFocusedElement.focus()
        }, 500)
      }
		}

	})
}

export const imgPath = (rootImg, index = 0, length = 1, isMobile = false) => {
  const baseImpolicy = '?impolicy=SGH_bgtransparent&width='
  const isImageSmallDesktop =
    !isMobile && (index < length - 1 || length % 2 === 0 || devicePixelRatio === 1)
  const isMobileRetina = isMobile && devicePixelRatio >= 2
  const isMobileNotRetina = isMobile && devicePixelRatio === 1
  if (isImageSmallDesktop || isMobileRetina) {
    return rootImg + baseImpolicy + '1024'
  }
  if (isMobileNotRetina) {
    return rootImg + baseImpolicy + '512'
  }
  return rootImg + baseImpolicy + '2048'
}

export const bytesToMB = (bytes) => {
  return bytes ? Number(bytes / (1024 * 1024)) : 0
}

export const runWhenIdle = (callback) => {
  /* Waiting for info about requestIdleCallback from Performance Team
  if (typeof window !== 'undefined' && window.requestIdleCallback) {
    window.requestIdleCallback(callback)
  } else {
    setTimeout(callback, 0)
  } */
  setTimeout(callback, 0)
}

export const decodeHtmlEntities = (str) => {
  const txt = document.createElement('textarea')
  txt.innerHTML = str
  return txt.value
}

export const resolveLazyComponent = (name)  => {
  try {
    if (!name) {
      console.warn('component name for lazy component is mandatory')
      return Promise.resolve(null)
    }
    const map  = LAZY_COMPONENTS_MAP
    if (!map[name]) {
      console.warn(`Component ${name} not found`)
      return Promise.resolve(null)
    }
    return map[name]()
  } catch (e) {
    console.error('error resolving lazy component',e)
    return Promise.resolve(null)
  }

}

export function generateRandomId(prefix = '') {
  const randomPart = Math.random().toString(36).slice(2, 9)
  return prefix ? `${prefix}-${randomPart}` : randomPart
}

